import React, {
  FunctionComponent,
  memo,
  useEffect,
} from 'react';
import { RootState } from '../../app/store';
import { ConnectedProps, connect } from 'react-redux';
import { RootDiv } from './styles';
import {
  receiveMessage,
  sendMessage,
} from '../../helpers/communication.helper';
import { TestResults } from '../../domains/results';
import { convertTestResultsToSheets } from '../../helpers/spreadsheet.helper';
import { addSheets } from './Spreadsheet.slice';


const connector = connect(
  (state: RootState) => ({
    sheets: state.spreadsheet.sheets,
  }),
  {
    addSheets,
  },
);

type PropsFromRedux = ConnectedProps<typeof connector>;

const Spreadsheet: FunctionComponent<PropsFromRedux> = ({
  sheets,
  addSheets,
}) => {
  useEffect(() => {
    const processCommunication = function () {
      receiveMessage(arguments[0], (m) => {
        if (m.command === 'check-loading') {
          sendMessage({ command: 'loaded' });
        }
        if (m.command === 'list-sheets') {
          const testResults: TestResults[] = m.data;
          const sheets = convertTestResultsToSheets(testResults);
          console.log(sheets);
          addSheets(sheets);
        }
      });
    };
    const closeTab = () => {
      sendMessage({ command: 'tab-closed' });
    };
    window.addEventListener('storage', processCommunication);
    window.addEventListener('beforeunload', closeTab);

    return () => {
      window.removeEventListener('storage', processCommunication);
      window.removeEventListener('beforeunload', closeTab);
      closeTab();
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const spreadSheet = $('#spreadsheet');
    const spreadSheetWidget = spreadSheet.data('kendoSpreadsheet');
    if (spreadSheetWidget) {
      spreadSheetWidget.destroy();
    }
    spreadSheet.empty();
    spreadSheet.kendoSpreadsheet({
      sheets: sheets,
    });
  }, [sheets]);

  return (
    <RootDiv>
      <div id="spreadsheet" />
    </RootDiv>
  );
};

export default memo(connector(Spreadsheet));
